var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "scrollContainer",
      staticClass: "a-container",
      staticStyle: { width: "100%", height: "100%", "overflow-y": "auto" },
      on: { scroll: _vm.scrollToTop },
    },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("全部订单")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c("form-filed", {
            ref: "formAttr",
            staticClass: "search-form1",
            attrs: {
              formconfig: _vm.searchFormConfig.formconfig,
              formData: _vm.searchFormConfig.formData,
            },
            on: { formDataval: _vm.dialogClick },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c("h3", [_vm._v("数据列表")]),
          _c(
            "div",
            {
              staticStyle: {
                "line-height": "28px",
                "margin-left": "10px",
                color: "#999999",
              },
            },
            [
              _vm._v("当前数据统计 实收金额"),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("￥" + _vm._s(_vm.actualReceivedAmount)),
              ]),
              _vm._v("，已通过审核的核销金额"),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("￥" + _vm._s(_vm.amount)),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "but-list" }, [
          _c(
            "div",
            { staticClass: "left" },
            _vm._l(_vm.logisticsStatus, function (val, key) {
              return _c(
                "el-button",
                {
                  key: key,
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: {
                    type: _vm.currentStatus === val.values ? "primary" : "info",
                    size: "small",
                    plain: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeLogisticsStatus(val.values)
                    },
                  },
                },
                [
                  _vm._v(_vm._s(val.title)),
                  _c("span", [_vm._v("(" + _vm._s(val.total) + ")")]),
                ]
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _vm.parArray.indexOf("Export_commission_list") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onComissionListExport()
                        },
                      },
                    },
                    [_vm._v("导出提成列表 ")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("Batch_import_commission") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onImport("4")
                        },
                      },
                    },
                    [_vm._v("批量导入提成")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("Export_audit_list") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onApplyListExport()
                        },
                      },
                    },
                    [_vm._v("导出审核列表 ")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("Batch_import_review") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onImport("3")
                        },
                      },
                    },
                    [_vm._v("批量导入审核")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("export_hx") != -1
                ? _c(
                    "el-button",
                    {
                      staticClass: "stay-deliver-goods-but",
                      attrs: { type: "warning", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onApplyListHExport()
                        },
                      },
                    },
                    [_vm._v("导出核销列表 ")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("batch_Import_Write_off") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onImport("1")
                        },
                      },
                    },
                    [_vm._v("批量导入核销 ")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("Export_order") != -1
                ? _c(
                    "el-button",
                    {
                      staticClass: "stock-up-send-but",
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onApplierExport()
                        },
                      },
                    },
                    [_vm._v("导出订单 ")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("Batch_import_orders") != -1
                ? _c(
                    "el-button",
                    {
                      staticClass: "stock-up-record-but",
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.onImport("2")
                        },
                      },
                    },
                    [_vm._v("批量导入订单 ")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("Download_order_template") != -1
                ? _c(
                    "el-button",
                    {
                      staticClass: "stay-deliver-goods-but",
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadlink(
                            "https://fenxiao.muruji.com/5eck/%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFv1.0.5.xls"
                          )
                        },
                      },
                    },
                    [_vm._v("下载订单模板 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table3", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: '"always"',
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.page.list,
                pagination: "",
                tableHeight: _vm.tableHeight,
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50, 200],
                "current-page": _vm.page.currentPage,
                "page-size": _vm.page.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
                "selection-change": _vm.handleSelectionChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "shenheList"
            ? [
                _c("audit-operation", {
                  ref: "shenheList",
                  attrs: {
                    orderObj: _vm.dialog.row,
                    dialogType: _vm.dialog.type,
                    afterNos: _vm.multipleSelection,
                    isBatch: _vm.dialog.batch,
                    isCleanUp: true,
                    orderAllId: _vm.currentRow.id,
                  },
                  on: { submitState: _vm.shenheState },
                }),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitApply()
                          },
                        },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "shenheStep"
            ? [
                _c("step-progress", {
                  attrs: {
                    apply: _vm.applys,
                    processFunc: _vm.dictionaries.process_func,
                    type: "shenheStep",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "logistics"
            ? [
                _c("StepLogistics", {
                  attrs: { stepProgress: _vm.logisticsNode },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "是否已核算提成",
            visible: _vm.isCommission,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isCommission = $event
            },
          },
        },
        [
          [
            _c(
              "el-form",
              {
                ref: "commissionForm",
                attrs: {
                  inline: true,
                  model: _vm.commissionForm,
                  size: "small",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "是否已核算提成", prop: "commissionFlag" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "400px" },
                        attrs: {
                          placeholder: "请选择是否已核算提成",
                          clearable: "",
                        },
                        model: {
                          value: _vm.commissionForm.commissionFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.commissionForm, "commissionFlag", $$v)
                          },
                          expression: "commissionForm.commissionFlag",
                        },
                      },
                      _vm._l(_vm.commissions, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "提成备注" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { type: "textarea", placeholder: "请输入" },
                      model: {
                        value: _vm.commissionForm.commissionRemark,
                        callback: function ($$v) {
                          _vm.$set(_vm.commissionForm, "commissionRemark", $$v)
                        },
                        expression: "commissionForm.commissionRemark",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialogBtnright",
                staticStyle: { "margin-top": "20px" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "setPay_payment_btn_quxiao",
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.isCommission = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "setPay_payment_btn_queren",
                    attrs: { type: "primary" },
                    on: { click: _vm.submitComission },
                  },
                  [_vm._v("提交")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入",
            visible: _vm.isImport,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isImport = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "popIn" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "tops",
                    staticClass: "upload-demo",
                    attrs: {
                      accept: ".doc,.docx,.xls,.xlsx,.csv",
                      drag: "",
                      action: "#",
                      multiple: false,
                      "http-request": _vm.orderImport,
                      limit: 1,
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(" 将文件拖到此处，或"),
                      _c("em", [_vm._v("点击上传")]),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "dialog-footer" }, [
              _c(
                "div",
                { on: { click: _vm.downloadTemplate } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "text", icon: "el-icon-download" } },
                    [_vm._v("导入模板下载")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "cancel",
                      on: {
                        click: function ($event) {
                          _vm.isImport = false
                        },
                      },
                    },
                    [_vm._v("取消 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "affirm",
                      attrs: { type: "primary" },
                      on: { click: _vm.submitF },
                    },
                    [_vm._v("确定 ")]
                  ),
                ],
                1
              ),
            ]),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.isPayment,
            width: "50%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isPayment = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.hList, border: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单编号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "receivableAmount", label: "订单应收金额" },
              }),
              _c("el-table-column", {
                attrs: { prop: "actualReceivedAmount", label: "订单实收金额" },
              }),
              _c("el-table-column", {
                attrs: { prop: "yAmount", label: "已核销总金额" },
              }),
              _c("el-table-column", {
                attrs: { prop: "otherAmount", label: "其他金额" },
              }),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "paymentForm",
              staticStyle: { "margin-top": "20px" },
              attrs: {
                model: _vm.paymentForm,
                "label-width": "100px",
                inline: true,
                rules: _vm.rules,
              },
            },
            [
              _vm._l(_vm.paymentForm.list, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("div", { staticClass: "p-title" }, [
                      _vm._v("第" + _vm._s(index + 1) + "笔核销"),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "结算方式",
                          prop: `list.${index}.settlementModes`,
                          rules: _vm.rules.settlementModes,
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "260px" },
                            attrs: {
                              size: "small",
                              placeholder: "请选择结算方式",
                              clearable: "",
                            },
                            model: {
                              value: item.settlementModes,
                              callback: function ($$v) {
                                _vm.$set(item, "settlementModes", $$v)
                              },
                              expression: "item.settlementModes",
                            },
                          },
                          _vm._l(_vm.settlementTypes, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "到账时间",
                          prop: "receiveTime",
                          prop: `list.${index}.receiveTime`,
                          rules: _vm.rules.receiveTime,
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            size: "small",
                            type: "date",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: "选择日期",
                          },
                          model: {
                            value: item.receiveTime,
                            callback: function ($$v) {
                              _vm.$set(item, "receiveTime", $$v)
                            },
                            expression: "item.receiveTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "回款渠道",
                          prop: "returnChannelId",
                          prop: `list.${index}.returnChannelId`,
                          rules: _vm.rules.returnChannelId,
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "260px" },
                            attrs: {
                              size: "small",
                              placeholder: "请选择回款渠道",
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: item.returnChannelId,
                              callback: function ($$v) {
                                _vm.$set(item, "returnChannelId", $$v)
                              },
                              expression: "item.returnChannelId",
                            },
                          },
                          _vm._l(_vm.channels, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "核销金额",
                          prop: `list.${index}.amount`,
                          rules: _vm.rules.amount,
                        },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            size: "small",
                            placeholder: "请输入核销金额",
                            oninput:
                              "value=value.replace(/^\\D*([0-9]\\d*\\.?\\d{0,2})?.*$/,'$1')",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeType($event)
                            },
                          },
                          model: {
                            value: item.amount,
                            callback: function ($$v) {
                              _vm.$set(item, "amount", $$v)
                            },
                            expression: "item.amount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm.paymentForm.list.length < 2
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "margin-top": "20px",
                        "margin-bottom": "20px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-plus" },
                          on: { click: _vm.addPrice },
                        },
                        [_vm._v("新增核销金额")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", {
                staticStyle: {
                  width: "100%",
                  height: "1px",
                  "background-color": "#e3e3e3",
                },
              }),
              _c(
                "div",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "核销类型",
                        prop: "status",
                        rules: _vm.rules.status,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "260px" },
                          attrs: {
                            size: "small",
                            placeholder: "请选择核销类型",
                            clearable: "",
                          },
                          model: {
                            value: _vm.paymentForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.paymentForm, "status", $$v)
                            },
                            expression: "paymentForm.status",
                          },
                        },
                        _vm._l(_vm.types, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "核销备注" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "630px" },
                        attrs: { type: "textarea", placeholder: "请输入" },
                        model: {
                          value: _vm.paymentForm.writeOffRemarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.paymentForm, "writeOffRemarks", $$v)
                          },
                          expression: "paymentForm.writeOffRemarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialogBtnright",
              staticStyle: { "margin-top": "20px" },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "setPay_payment_btn_quxiao",
                  attrs: { type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.isPayment = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "setPay_payment_btn_queren",
                  attrs: { type: "primary" },
                  on: { click: _vm.actionDialog },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }